function loadScript(url, callback, callbackError) {
  var script = document.createElement('script');
  script.type = 'text/javascript';

  try {
    if (script.readyState) {
      //IE
      script.onreadystatechange = function () {
        if (
          script.readyState === 'loaded' ||
          script.readyState === 'complete'
        ) {
          script.onreadystatechange = null;
          if (callback) callback();
        }
      };
    } else {
      //其餘瀏覽器支援onload
      script.onload = function () {
        if (callback) callback();
      };
    }

    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
  } catch (e) {
    if (null !== callbackError) callbackError(e);
  }
}

function _hotjar() {
  (function (h, o, t, j, a, r) {
    h.hj =
      h.hj ||
      function () {
        (h.hj.q = h.hj.q || []).push(arguments);
      };
    h._hjSettings = { hjid: 1833226, hjsv: 6 };
    a = o.getElementsByTagName('head')[0];
    r = o.createElement('script');
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
}

export default function loadServices() {
  _hotjar();
}

export function loadRecapcha(siteKey) {
  loadScript('https://www.google.com/recaptcha/api.js?render=' + siteKey);
}
